import { useState, useEffect } from 'react';
import axios from "axios";
import {
    getCallLogFormAPIList
} from './../../utils/APIClient'
import moment from 'moment'
import { createThemeData, customStyles } from './../../utils/Constants'
import DataTable, { createTheme } from "react-data-table-component";
import { getOnlyToken } from '../../utils/commonFunctions';
export default function Call_Logs() {
    document.title = "Callingo | Payment History"
    const today = moment().format('YYYY-MM-DD');
    const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
    const [startDate, setStartDate] = useState(sevenDaysAgo);
    const [endDate, setEndDate] = useState(today);
    const [ActivityLog, setActivityLog] = useState([])
    const [cardData, setCardData] = useState([])
    const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)

    const [search, setsearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedConversation, setSelectedConversation] = useState(null);

    createTheme('solarized', createThemeData, 'dark');
    const columns = [
        {
            name: "Call ID",
            selector: (row) => row.call_id,
            cell: row => row.call_id,
        },
        {
            name: "Agent",
            selector: (row) => row.agent_name,
            cell: row => row.agent_name,
        },
        {
            name: "Customer Name",
            selector: (row) => row.target_lead_name,
            cell: row => row.target_lead_name,
        },
        {
            name: "Customer Phone Number",
            selector: (row) => row.target_lead_phone,
            cell: row => row.target_lead_phone,
        },
        {
            name: "Start Time",
            selector: (row) => row.start_time,
            cell: row => row.start_time,
        },
        {
            name: "Duration",
            selector: (row) => row.Duration,
            sortable: true
        },
        {
            name: "Call Status",
            selector: (row) => row.call_status,
            cell: row => {
                let colorClass = "text-secondary";
                if (row.call_status) {
                    const status = row.call_status.toLowerCase();
                    if (status === "completed") colorClass = "text-success";
                    else if (status === "scheduled") colorClass = "text-primary";
                    else if (status === "not_answered") colorClass = "text-warning";
                    else if (status === "failed" || status === "fail") colorClass = "text-danger";
                }
                return (
                    <span className={colorClass + " fw-bold"}>
                        {row.call_status || "-"}
                    </span>
                );
            },
        },

        {
            name: "Transcription",
            cell: (row) => {
                const audioUrl = row.call_conversation?.record || null;

                return (
                    <div className="d-flex align-items-center gap-2">
                        {/* View Transcription */}
                        <button
                            type="button"
                            className="btn btn-sm btn-success"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasScrolling"
                            aria-controls="offcanvasScrolling"
                            onClick={() => setSelectedConversation({
                                call_id: row.call_id,
                                conversation: row.call_conversation?.conversation || [],
                                record: audioUrl
                            })}

                        >
                            <i className="ri-eye-line"></i>
                        </button>

                        {/* Native Audio Player */}
                        {audioUrl ? (
                            <audio controls style={{ height: "28px", width: "120px" }}>
                                <source src={audioUrl} type="audio/wav" />
                                Your browser does not support the audio element.
                            </audio>
                        ) : (
                            <span className="text-muted small">No audio</span>
                        )}
                    </div>
                );
            }
        }






    ]

    const getCallingoActivity = async (
        pagesize,
        pagenumber,
        searchs = search,
        from_date = startDate,
        to_date = endDate
    ) => {
        setpage_size(pagesize);
        setLoading(true);

        let url = `api/agents/single-call/list-with-summary/?from_date=${moment(from_date).format(
            "DD-MM-YYYY"
        )}&to_date=${moment(to_date).format(
            "DD-MM-YYYY"
        )}&page=${pagenumber}&per_page=${pagesize}${searchs && `&search=${searchs}`
            }`;

        try {
            let res = await getCallLogFormAPIList(url);
            if (res.data) {
                const processedData = res.data.call_data.map((item) => {
                    let duration = null;

                    if (item.call_conversation && item.call_conversation.call_duration) {
                        // Convert seconds to mm:ss format
                        const totalSeconds = parseInt(item.call_conversation.call_duration, 10);
                        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
                        const seconds = String(totalSeconds % 60).padStart(2, "0");
                        duration = `${minutes}:${seconds}`;
                    }

                    return {
                        ...item,
                        Duration: duration || "N/A",
                    };
                });
                setCardData(res.data);
                setActivityLog(processedData);
                settotalPages(res.data.pagination.total_items);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    const handlePageChange = page => {
        getCallingoActivity(page_size, page)
        setpage_number(page);
    };

    const handlePerRowsChange = async (newPerPage, page = page_number) => {
        getCallingoActivity(newPerPage, page)
        setpage_size(newPerPage);
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    useEffect(() => {
        getCallingoActivity(page_size, page_number)
    }, [])

    const sendCallRecordEmail = async (callId) => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        try {
            const payload = { call_id: callId };

            const response = await axios.post(
                "/api/agents/send-call-record-email/",
                payload,
                config
            );

            if (response.status === 200) {
                alert("Email sent successfully!");
            } else {
                alert("Failed to send email. Please try again.");
            }
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Something went wrong while sending email.");
        }
    };

    return (
        <>


            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <div className="page-title-right">
                            <div className="d-flex align-items-center gap-2">
                                <div className="app-search ">
                                    <form>
                                        <div className="input-group">
                                            <input type="search" className="form-control search-form" placeholder="Search Assistant Name" id="top-search" onChange={(e) => { setsearch(e.target.value); getCallingoActivity(page_size, page_number, e.target.value, startDate, endDate) }} />
                                            <span className="ri-search-line search-icon"></span>
                                        </div>
                                    </form>
                                </div>
                                <p className="text-nowrap mb-0">Select Range</p>
                                <div className="input-group date-input">

                                    <input type="date" className="form-control shadow form-control-custom  border-0" id="dash-daterange" max={endDate} value={startDate} onChange={(e) => { setStartDate(e.target.value); e.target.value && getCallingoActivity(page_size, page_number, search, e.target.value, endDate) }} />
                                </div>
                                <p className="text-nowrap mb-0 ">to</p>
                                <div className="input-group date-input">

                                    <input type="date" className="form-control form-control-custom shadow border-0 search-form" id="dash-daterange" max={endDate} value={endDate} onChange={(e) => { setEndDate(e.target.value); e.target.value && getCallingoActivity(page_size, page_number, search, startDate, e.target.value) }} />
                                </div>
                            </div>
                        </div>
                        <h4 className="page-title">Call logs</h4>
                    </div>
                </div>
            </div>
            <div className="row  mb-1">
                <div className="col-xl-3 col-lg-6">
                    <div className="card cta-box overflow-hidden cal-minut">
                        <div className="card-body pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3 className="mt-0  cta-box-title mb-1">Current</h3>
                                    <h2 className="my-2 cta-box-title py-1" > {cardData.current_count}</h2>
                                </div>
                                <img className="ms-3" src="assets/images/users/call-back.png" width="75" alt="Generic placeholder image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6">
                    <div className="card cta-box overflow-hidden numof-call">
                        <div className="card-body pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3 className="mt-0 cta-box-title mb-1">Scheduled</h3>
                                    <h2 className="my-2 cta-box-title py-1" >{cardData.scheduled_count}</h2>
                                </div>
                                <img className="ms-3" src="assets/images/users/number-of-calls.png" width="80" alt="Generic placeholder image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6">
                    <div className="card cta-box overflow-hidden total-spent">
                        <div className="card-body pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3 className="mt-0  cta-box-title mb-1 ">Success</h3>
                                    <h2 className="my-2 cta-box-title py-1" >{cardData.success_count}</h2>
                                </div>
                                <img className="ms-3" src="assets/images/users/spent.png" width="80" alt="Generic placeholder image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6">
                    <div className="card cta-box overflow-hidden average-cost">
                        <div className="card-body pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3 className="mt-0  cta-box-title mb-1 ">Failed</h3>
                                    <h2 className="my-2 cta-box-title py-1" >{cardData.failed_count}</h2>
                                </div>
                                <img className="ms-3" src="assets/images/users/call-failed.png" width="70" alt="Generic placeholder image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <p className="  ">Note : The filter counts reflect only the logs currently loaded in the table.  </p>
                {loading ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> :

                    <DataTable
                        columns={columns}
                        fixedHeader

                        persistTableHead
                        data={ActivityLog}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPages}
                        paginationDefaultPage={page_number}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationPerPage={page_size}

                        theme="solarized"
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />}
            </div>

            <div className="offcanvas offcanvas-end canvas-width" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
                <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel" className="text-green">Transcription Summary</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>

                <div className="offcanvas-body d-flex flex-column" style={{ height: "100%" }}>
                    {/* Conversation Messages */}
                    <div className="flex-grow-1 overflow-auto">
                        {selectedConversation?.conversation?.length > 0 ? (
                            <ul className="conversation-list p-1">
                                {selectedConversation.conversation.map((msg, index) => (
                                    <li
                                        key={index}
                                        className={`clearfix ${msg.role === "ai" ? "odd" : ""}`}
                                    >
                                        <div className="conversation-text">
                                            <div className="ctext-wrap">
                                                <i>{msg.role === "ai" ? "AI Assistant" : "User"}</i>
                                                <p>{msg.content}</p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-muted">No transcription available for this call.</p>
                        )}
                    </div>

                    {/* Share Buttons */}
                    <div className="mt-3 border-top pt-2">
                        <button
                            className="btn btn-success w-100 mb-2"
                            onClick={() => {
                                if (selectedConversation?.record) {
                                    const message = encodeURIComponent(`Here is the call recording: ${selectedConversation.record}`);
                                    window.open(`https://web.whatsapp.com/send?text=${message}`, "_blank");
                                } else {
                                    alert("No audio file available to share.");
                                }
                            }}
                        >
                            <i className="ri-whatsapp-line me-1"></i> Share via WhatsApp
                        </button>

                        <button
                            className="btn btn-primary w-100"
                            onClick={() => {
                                if (selectedConversation?.call_id) {
                                    sendCallRecordEmail(selectedConversation.call_id);
                                } else {
                                    alert("No call ID available to share.");
                                }
                            }}
                        >
                            <i className="ri-mail-line me-1"></i> Share via Email
                        </button>


                    </div>
                </div>

            </div>


        </ >
    )
}
